import ActioncableController from "controllers/actioncable_controller"
import AlertController from "./alert_controller"
import DatatableController from "controllers/datatable_controller"
import DropdownController from "controllers/dropdown_controller"
import FetchController from "controllers/fetch_controller"
import OtpInputController from "controllers/otp_input_controller"
import PeopleActionsController from "controllers/people/actions_controller"
import PeopleFormController from "controllers/people/form_controller"
import PeopleImportController from "controllers/people/import_controller"
import PeopleSearchController from "controllers/people/search_controller"
import PeopleSpecialClassesController from "controllers/people/special_classes_controller"
import SidebarTooltipController from "controllers/sidebar-tooltip_controller"
import StickyTableController from "controllers/sticky-table_controller"
import TabsController from "controllers/tabs_controller"
import TooltipController from "controllers/tooltip_controller"
import UsersAuthenticationFormController from "controllers/users/authentication_form_controller"
import UsersChangePasswordController from "controllers/users/change_password_controller"
import UsersCredentialActionsController from "controllers/users/credential_actions_controller"
import UsersDisableTfaController from "controllers/users/disable_tfa_controller"
import UsersFormController from "controllers/users/form_controller"
import UsersGenerateTfaBackupCodesController from "controllers/users/generate_tfa_backup_codes_controller"
import UsersSetupTfaController from "controllers/users/setup_tfa_controller"
import UsersTfaWarningController from "controllers/users/tfa_warning_controller"

function registerCommonControllers(application) {
  application.register("actioncable", ActioncableController)
  application.register("alert", AlertController)
  application.register("datatable", DatatableController)
  application.register("dropdown", DropdownController)
  application.register("fetch", FetchController)
  application.register("otp-input", OtpInputController)
  application.register("people--actions", PeopleActionsController)
  application.register("people--form", PeopleFormController)
  application.register("people--import", PeopleImportController)
  application.register("people--search", PeopleSearchController)
  application.register("people--special-classes", PeopleSpecialClassesController)
  application.register("sidebar-tooltip", SidebarTooltipController)
  application.register("sticky-table", StickyTableController)
  application.register("tabs", TabsController)
  application.register("tooltip", TooltipController)
  application.register("users--authentication-form", UsersAuthenticationFormController)
  application.register("users--change-password", UsersChangePasswordController)
  application.register("users--credential-actions", UsersCredentialActionsController)
  application.register("users--disable-tfa", UsersDisableTfaController)
  application.register("users--form", UsersFormController)
  application.register("users--generate-tfa-backup-codes", UsersGenerateTfaBackupCodesController)
  application.register("users--setup-tfa", UsersSetupTfaController)
  application.register("users--tfa-warning", UsersTfaWarningController)
}

export { 
  registerCommonControllers,
  ActioncableController,
  AlertController,
  DatatableController,
  DropdownController,
  FetchController,
  OtpInputController,
  PeopleActionsController,
  PeopleFormController,
  PeopleImportController,
  PeopleSearchController,
  PeopleSpecialClassesController,
  SidebarTooltipController,
  StickyTableController,
  TabsController,
  TooltipController,
  UsersAuthenticationFormController,
  UsersChangePasswordController,
  UsersCredentialActionsController,
  UsersDisableTfaController,
  UsersFormController,
  UsersGenerateTfaBackupCodesController,
  UsersSetupTfaController,
  UsersTfaWarningController
 }